var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBambooHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12941",
    "data-name": "Group 12941",
    transform: "translate(-813 -361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M-194.3,407.5a6.273,6.273,0,0,1-6.3-6.3,6.3,6.3,0,0,1,6.4-6.6,6.249,6.249,0,0,1,6.3,6.5,6.142,6.142,0,0,1-6.4,6.4m.3-15.5a7.9,7.9,0,0,0-6.1,2.3l-.3.3V384h-2.7v17.3a8.54,8.54,0,0,0,8.8,8.7,8.946,8.946,0,0,0,9.1-9.1A8.965,8.965,0,0,0-194,392",
    transform: "translate(1030.198 -23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M-204.4,395.5s-1.2-.2-2.2-.4a12.625,12.625,0,0,1-3.1-.9,11.114,11.114,0,0,1-4-3.6,42.153,42.153,0,0,0-4.3-4.1s.9.1,1.9.3a21.567,21.567,0,0,1,4.8,1.9,7.458,7.458,0,0,1,1.2.7,11.208,11.208,0,0,1,2.1,1.8c.8.8,1.5,1.5,2.1,2.2-.7-1.2-2.4-5.6-5.7-9.2-.3-.4,2.3,1.3,3,2a12.321,12.321,0,0,1,3,5.4Z",
    transform: "translate(1031 -23)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBambooHr);
export default __webpack_public_path__ + "static/media/bambooHr.291fea69df2cafc6607ba4d9fd8c1e44.svg";
export { ForwardRef as ReactComponent };